import AssignmentRatesDefaultModal from "@app/components/modals/assignments/rates/assignment-rates-default-modal.tsx";
import AssignmentRatesExpenseModal from "@app/components/modals/assignments/rates/assignment-rates-expense-modal.tsx";
import useAssignmentData from "@app/data-hooks/use-assignment-data.ts";
import { assignmentDefaultExpenseRatesTableDefinition } from "@app/table-definitions/assignment-default-expense-rates.table-definition.tsx";
import { assignmentExpenseRateDetailsTableDefinition } from "@app/table-definitions/assignment-expense-rate-details.table-definition.tsx";
import { Button, Stack } from "@mui/material";
import { DataTable } from "bi-lib";
import { useState } from "react";

interface Props {
    id: number;
}

export default function AssignmentRatesForm({ id }: Props) {
    const [expenseId, setExpenseId] = useState<number>();
    const [expenseRateOpen, setExpenseRateOpen] = useState(false);
    const [defaultId, setDetailId] = useState<number>();
    const [detailDefaultsOpen, setDetailDefaultsOpen] = useState(false);

    const { expenseDetailsList, deleteExpenseDetail, assignmentDetailGrid, deleteAssignmentDetail } = useAssignmentData(
        {
            id: id,
        },
    );

    return (
        <>
            <AssignmentRatesExpenseModal
                open={expenseRateOpen}
                onClose={() => {
                    setExpenseRateOpen(false);
                    setExpenseId(undefined);
                }}
                id={expenseId}
                assignmentId={id}
            />
            <AssignmentRatesDefaultModal
                open={detailDefaultsOpen}
                onClose={() => {
                    setDetailDefaultsOpen(false);
                    setDetailId(undefined);
                }}
                id={defaultId}
                assignmentId={id}
            />
            <Stack spacing={2}>
                <DataTable
                    rowsPerPageOptions={[5000]}
                    label={"Default Expense Rates"}
                    actions={
                        <Button variant={"contained"} onClick={() => setExpenseRateOpen(true)}>
                            Add New
                        </Button>
                    }
                    columns={assignmentDefaultExpenseRatesTableDefinition({
                        onEdit: (id) => {
                            setExpenseRateOpen(true);
                            setExpenseId(id);
                        },
                        onDelete: (id) => deleteExpenseDetail.mutate(id),
                        rowCount: expenseDetailsList.data?.length ?? 0,
                    })}
                    data={expenseDetailsList.data ?? []}
                    queryHook={expenseDetailsList}
                />
                <DataTable
                    rowsPerPageOptions={[5000]}
                    label={"Detail Defaults"}
                    actions={
                        <Button variant={"contained"} onClick={() => setDetailDefaultsOpen(true)}>
                            Add New
                        </Button>
                    }
                    columns={assignmentExpenseRateDetailsTableDefinition({
                        onEdit: (id) => {
                            setDetailDefaultsOpen(true);
                            setDetailId(id);
                        },
                        onDelete: (id) => deleteAssignmentDetail.mutate(id),
                        rowCount: assignmentDetailGrid.data?.length ?? 0,
                    })}
                    data={assignmentDetailGrid.data ?? []}
                    queryHook={assignmentDetailGrid}
                />
            </Stack>
        </>
    );
}
